import { Link, useLocation } from '@remix-run/react';
import { WebRoutes } from '@theprintbar/shared';
import { BrandStarAnimated, RichText } from '@theprintbar/ui';
import { Container } from '@theprintbar/ui';
import { RootLoaderData } from '~/root';
import { BackToTopButton } from '../../../../../packages/ui/src/components/BackToTopButton/BackToTopButton';
import { Socials } from '../Socials';
import { Acknowledges } from './components/Acknowledges';
import { BusinessDetails } from './components/BusinessDetails';
import { Community } from './components/Community';
import { More } from './components/More';

interface FooterProps {
	data: RootLoaderData;
}

export function Footer({ data }: FooterProps) {
	const { globalContent } = data;
	const { pathname } = useLocation();

	const hiddenRoutes = [WebRoutes.Checkout.Information, WebRoutes.PaymentRequest.Base];
	return !!hiddenRoutes.find(r => pathname.includes(r)) ? null : (
		<footer className="bg-blue text-gray-100 pt-20 pb-4 lg:pb-8 lg:pt-36">
			<Container className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-16">
				{globalContent.tiles.structure?.map(item =>
					!item ? null : (
						<div key={item.title} className="space-y-2 flex flex-col items-start text-left ">
							<img loading="lazy" src={item.icon?.image.url} alt={item.icon?.altText || 'icon'} className="w-4 h-4" />
							<h4 className="font-display font-light text-lg lg:text-xl">
								{item.link ? <Link to={item.link}>{item.title}</Link> : item.title}
							</h4>
							<RichText {...item.text} className="hidden sm:block font-sans" />
						</div>
					),
				)}

				<div className="col-span-2 lg:col-span-1 grid grid-cols-2 text-lg lg:grid-none lg:flex lg:flex-col gap-x-16 gap-y-2.5">
					{globalContent.links.structure?.map(link => (
						<Link key={link?.text} className="font-display font-light text-lg md:text-xl" to={link?.to || '#'}>
							{link?.text}
						</Link>
					))}
				</div>

				{/* Business Info */}
				<BusinessDetails data={globalContent} />

				{/* MOBILE */}
				<More data={globalContent} className="lg:hidden" />
				<Acknowledges data={globalContent} className="lg:hidden col-span-2" />
				<Community data={globalContent} className="col-span-2 lg:hidden" />

				{/* DESKTOP */}
				<div className="col-span-2 hidden lg:grid grid-cols-2 gap-x-16 gap-y-12">
					<More data={globalContent} />
					<Community data={globalContent} />
					<Acknowledges data={globalContent} className="col-span-2" />
				</div>

				<BrandStarAnimated className="w-12 h-12 fill-white" />

				<div className="flex col-span-2 lg:col-span-1 flex-wrap items-center space-x-3 justify-between">
					<Socials data={data} colour="white" />
					<BackToTopButton className="lg:hidden">Back to top</BackToTopButton>
				</div>

				<BackToTopButton className="hidden lg:flex w-max my-auto text-white border border-white fill-white hover:scale-105 transition-all">
					Back to top
				</BackToTopButton>
			</Container>
		</footer>
	);
}
